import { Button, Col, Form, Layout, Row, Select, DatePicker, Icon } from "antd";
import React, { Component } from "react";
const { Content } = Layout;

class PaymentLogFilter extends Component {
  state = {
    date1: null,
    date2: null,
  };

  onFinish = (e) => {
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (!err) {
        const finalOutput = {
          ...values,
        };

        if (values["start"] && !values["end"]) {
          finalOutput["created "] =
            values["start"].format("YYYY-MM-DD") +
            ":" +
            values["start"].format("YYYY-MM-DD");
        }

        if (values["end" && !values["start"]]) {
          finalOutput["created "] =
            values["end"].format("YYYY-MM-DD") +
            ":" +
            values["end"].format("YYYY-MM-DD");
        }

        if (values["start"] && values["end"]) {
          finalOutput["created"] =
            values["start"].format("YYYY-MM-DD") +
            ":" +
            values["end"].format("YYYY-MM-DD");
        }

        delete finalOutput.start;
        delete finalOutput.end;

        const parsedJson = JSON.stringify(finalOutput);

        //callback
        this.props.onSubmit(parsedJson);
      }
    });
  };

  onResetBtn = () => {
    this.setState({ date1: null, date2: null });
    this.props.form.resetFields();
    this.props.onSubmit();
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { adminList } = this.props;

    // add `ลูกค้า` to adminList
    if (!Boolean(adminList.find((item) => item.id === 0))) {
      adminList.unshift({ id: "0", firstname: "ลูกค้า", lastname: "" });
    }

    return (
      <Content
        style={{
          background: "#fff",
          padding: 24,
          margin: "16px 0",
        }}
      >
        <Form
          name="filter-forms"
          colon={false}
          onSubmit={this.onFinish}
          hideRequiredMark
        >
          <Row gutter={8}>
            <Col xl={6}>
              <Form.Item name="admin_id" label="ผู้กระทำ">
                {getFieldDecorator("admin_id")(
                  <Select showSearch allowClear placeholder="เลือกผู้กระทำ">
                    {adminList.map((c) => {
                      const { id, firstname, lastname } = c;
                      const name = firstname + " " + lastname;
                      return (
                        <Select.Option key={id} value={id}>
                          {name}
                        </Select.Option>
                      );
                    })}
                  </Select>
                )}
              </Form.Item>
            </Col>
            <Col xl={6}>
              <Form.Item name="start" label="วันที่">
                {getFieldDecorator("start")(
                  <DatePicker
                    style={{ width: "100%" }}
                    disabledDate={(c) => {
                      if (this.state.date2) {
                        return c > this.state.date2;
                      }
                      return;
                    }}
                    onChange={(d) => this.setState({ date1: d })}
                  />
                )}
              </Form.Item>
            </Col>
            <Col xl={6}>
              <Form.Item name="end" label="&nbsp;">
                {getFieldDecorator("end")(
                  <DatePicker
                    style={{ width: "100%" }}
                    disabledDate={(c) => {
                      if (this.state.date1) {
                        return c <= this.state.date1;
                      }
                      return;
                    }}
                    onChange={(d) => this.setState({ date2: d })}
                  />
                )}
              </Form.Item>
            </Col>
            <Col xl={6}>
              <Form.Item label="&nbsp;">
                <Button
                  style={{ margin: "0 4px 0 4px" }}
                  onClick={() => this.onResetBtn()}
                >
                  <Icon type="redo" />
                </Button>
                <Button
                  style={{ margin: "0 4px 0 4px" }}
                  type="primary"
                  htmlType="submit"
                >
                  <Icon type="enter" />
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Content>
    );
  }
}

export default Form.create({ name: "payment_log_filters" })(PaymentLogFilter);



// WEBPACK FOOTER //
// ./src/containers/PaymentLog/form.js